var map = {
	"./custom/app/shared/loading/loading.component": [
		26295,
		[
			"default-src_app_shared_loading_loading_component_ts",
			"src_themes_custom_app_shared_loading_loading_component_ts"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 54512;
module.exports = webpackAsyncContext;